import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/product-thumb-sm.png'


const _hoisted_1 = {
  key: 0,
  class: "productFull"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "mt-5" }
const _hoisted_5 = { class: "grid productInfoGrid" }
const _hoisted_6 = {
  key: 0,
  class: "col"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text-color-um-blue" }
const _hoisted_9 = { class: "product__accordion" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "col"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "text-color-um-blue" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  key: 2,
  class: "col"
}
const _hoisted_17 = ["alt"]
const _hoisted_18 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("strong", { style: {"font-size":"18px"} }, "Photo gallery...", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "icon-chevron-right" }, null, -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("hr", { class: "my-5" }, null, -1)
const _hoisted_25 = { class: "grid" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "text-color-um-blue" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "col" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", { class: "text-color-um-blue" }, "Location")
], -1)
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<hr class=\"my-5\"><div class=\"grid\"><div class=\"col\"><p><strong class=\"text-color-um-blue\">Classification</strong></p><p><strong> Areas <br> Category MERIL <br> Category Uni-Leeds </strong></p></div><div class=\"col\"><p><strong class=\"text-color-um-blue\">Access type</strong></p><p><strong>Free</strong></p></div><div class=\"col\"><p><strong class=\"text-color-um-blue\">Access method</strong></p><p><strong>Physical</strong></p></div><div class=\"col\"><p><strong class=\"text-color-um-blue\">Life cycle status of equipment</strong></p><p><strong>Active</strong></p></div><div class=\"col\"><p><strong class=\"text-color-um-blue\">Target user groups</strong></p><p><strong>UM Researchers</strong></p></div></div><hr class=\"my-5\"><div class=\"grid\"><div class=\"col\"><p><strong class=\"text-color-um-blue\">Equipment access procedure</strong></p><p> Lorem ipsum dolor sit amet, ut duo congue volutpat. Id vim nusquam reprehendunt, at mazim detraxit recusabo pri. Nec at clita partem impedit. Ullum instructior mei et, eos eu dicant tempor, vel ei percipit salutandi. Ne quem iriure oblique mei, explicari principes tincidunt mea ad. Id labore persius oporteat sit, ne malorum scripserit reformidans sit. Duo ne corrumpit eloquentiam, usu oblique sensibus eu. Ius probo theophrastus an, illum nullam nec cu. </p></div><div class=\"col\" style=\"max-width:600px;\"><ul class=\"ul--arrow\"><li>Step 1</li><li>Step 2</li><li>Step 3</li></ul></div></div><hr class=\"my-5\">", 5)
const _hoisted_37 = { class: "grid" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", { class: "text-color-um-blue" }, "Equipment use price list")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " Lorem ipsum dolor sit amet, ut duo congue volutpat. Id vim nusquam reprehendunt, at mazim detraxit recusabo pri. Nec at clita partem impedit. Ullum instructior mei et, eos eu dicant tempor, vel ei percipit salutandi. Ne quem iriure oblique mei, explicari principes tincidunt mea ad. Id labore persius oporteat sit, ne malorum scripserit reformidans sit. Duo ne corrumpit eloquentiam, usu oblique sensibus eu. Ius probo theophrastus an, illum nullam nec cu. ")
], -1)
const _hoisted_39 = {
  class: "col",
  style: {"max-width":"600px"}
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-5 mb-4" }, null, -1)
const _hoisted_45 = { style: {"max-width":"250px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Galleria = _resolveComponent("Galleria")!
  const _component_IconTextBlock = _resolveComponent("IconTextBlock")!
  const _component_GoogleMapsSmall = _resolveComponent("GoogleMapsSmall")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_AddToCompare = _resolveComponent("AddToCompare")!
  const _component_Button = _resolveComponent("Button")!

  return (_ctx.product)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h3", {
          class: "text-color-um-blue",
          innerHTML: _ctx.product.title
        }, null, 8, _hoisted_2),
        _createElementVNode("p", {
          innerHTML: _ctx.product.description
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.product.accordion)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.accordion, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (item.title)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                            _createElementVNode("strong", _hoisted_8, _toDisplayString(item.title), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_9, [
                        (item.children)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createVNode(_component_Accordion, null, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, index_child) => {
                                    return (_openBlock(), _createBlock(_component_AccordionTab, {
                                      key: index_child,
                                      header: child.title
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(child.content), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["header"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.product.linkList)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.linkList, (list, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "product__list"
                    }, [
                      (list.title)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                            _createElementVNode("strong", _hoisted_13, _toDisplayString(list.title), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (list.children)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.children, (child, index_child) => {
                              return (_openBlock(), _createElementBlock("p", { key: index_child }, [
                                (child.href)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: _ctx.href,
                                      class: "link",
                                      target: "_blank"
                                    }, _toDisplayString(child.title), 9, _hoisted_15))
                                  : (child.to)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 1,
                                        class: "link",
                                        to: child.to
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(child.title), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]))
                                    : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.productImage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", {
                    class: "absImgBG",
                    style: _normalizeStyle([
              _ctx.productImage ? 'background-image:url(' + _ctx.productImage + ')' : '',
            ])
                  }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: _ctx.product.title
                    }, null, 8, _hoisted_17)
                  ], 4),
                  (_ctx.product.gallery)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "read-more text-color-blue mt-2",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showGallery = true), ["prevent"]))
                        }, _hoisted_21),
                        _createVNode(_component_Galleria, {
                          visible: _ctx.showGallery,
                          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showGallery) = $event)),
                          value: _ctx.product.gallery,
                          "num-visible": 6,
                          "container-style": "max-width: 50%",
                          circular: true,
                          "full-screen": true,
                          "show-item-navigators": true
                        }, {
                          item: _withCtx((slotProps) => [
                            _createElementVNode("img", {
                              src: slotProps.item.itemImageSrc,
                              alt: slotProps.item.alt,
                              style: {"width":"100%","display":"block"}
                            }, null, 8, _hoisted_22)
                          ]),
                          thumbnail: _withCtx((slotProps) => [
                            _createElementVNode("img", {
                              src: slotProps.item.thumbnailImageSrc,
                              alt: slotProps.item.alt,
                              style: {"display":"block"}
                            }, null, 8, _hoisted_23)
                          ]),
                          _: 1
                        }, 8, ["visible", "value"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          (_ctx.product.infoList)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.product.infoList, (list, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "col"
                }, [
                  (list.title)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                        _createElementVNode("strong", _hoisted_27, _toDisplayString(list.title), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (list.children)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.children, (child, index_child) => {
                          return (_openBlock(), _createElementBlock("p", { key: index_child }, [
                            _createVNode(_component_IconTextBlock, {
                              icon: child.icon,
                              label: child.label,
                              to: child.to,
                              href: child.href
                            }, null, 8, ["icon", "label", "to", "href"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_29, [
            (_ctx.product.location)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode(_component_GoogleMapsSmall, {
                    location: _ctx.product.location
                  }, null, 8, ["location"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_32,
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_DataTable, { value: _ctx.tableData }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "user",
                  header: "User"
                }),
                _createVNode(_component_Column, null, {
                  header: _withCtx(() => [
                    _createTextVNode("From"),
                    _hoisted_40,
                    _createTextVNode("To")
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { field: "date_1" }, {
                  header: _withCtx(() => [
                    _createTextVNode("01.01.2021"),
                    _hoisted_41,
                    _createTextVNode("01.06.2021")
                  ]),
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.data.date_1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { field: "date_2" }, {
                  header: _withCtx(() => [
                    _createTextVNode("01.01.2021"),
                    _hoisted_42,
                    _createTextVNode("01.06.2021")
                  ]),
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.data.date_2), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { field: "date_3" }, {
                  header: _withCtx(() => [
                    _createTextVNode("01.01.2021"),
                    _hoisted_43,
                    _createTextVNode("01.06.2021")
                  ]),
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.data.date_3), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ]),
        _hoisted_44,
        _createElementVNode("div", _hoisted_45, [
          (_ctx.compare)
            ? (_openBlock(), _createBlock(_component_AddToCompare, {
                key: 0,
                id: _ctx.productID,
                class: "mb-4"
              }, null, 8, ["id"]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            class: "router-link w-full",
            to: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Button, {
                type: "button",
                class: "p-button-iconEdge w-full",
                icon: "icon-chevron-right",
                "icon-pos": "right",
                label: "BOOK THIS EQUIPMENT"
              })
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}